<h2 mat-dialog-title mat-dialog-draggable-title>
     {{ 'config_enterprise.add_ip_file'| translate }}
    <button type="button" class="close" aria-label="Close" cdkFocusInitial (click)="onNoClick()">
        <span aria-hidden="true">&times;</span>
    </button>
</h2>
<mat-divider></mat-divider>
<mat-card>
    <form>
        <mat-card-content class="mat-card-content-contract-sm" style="margin-bottom: 0 !important;">
            <mat-accordion #accordion="matAccordion" [multi]="true">
                <mat-expansion-panel [expanded]="true" class="mb-3 mt-3" [disabled]="true">
                    <mat-expansion-panel-header>
                        <mat-panel-title class="mat-panel-title" style="color: rgba(0,0,0,.87);">
                            {{ "config_enterprise.file_info" | translate }}
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="form-group row">
                        <div class="col-12">
                            <table>
                                <tr>
                                    <td>{{"config_enterprise.upload_file_data" |
                                        translate }}<span style="color: #fc1203">*</span>
                                    </td>

                                    <td>
                                        <span [matTooltip]="documentTypeEnterprise?.name">{{
                                            documentTypeEnterprise?.name }}</span>
                                    </td>
                                    <td *ngIf="fileName" style="max-width: 75vw;" class="pr-3">
                                        <span class="file-name" [class.error-file]="errorFile"
                                            style="word-break: break-word">{{
                                            fileName
                                            }}</span>
                                    </td>
                                    <td>
                                        <input type="file" id="file" name="file" style="display: none"
                                            (change)="onChangeFile($event)" accept=".xlsx"
                                            onclick="this.value = null" />
                                        <button mat-raised-button color="primary" type="button" (click)="uploadFile()"
                                            *ngIf="!fileName">
                                            <mat-icon class="mr-0" style="vertical-align: middle;width: auto;
                                            height: auto;">cloud_upload</mat-icon>
                                            {{ "button.choose_file" | translate }}
                                        </button>
                                        <button color="primary" mat-stroked-button type="button" (click)="uploadFile()"
                                            *ngIf="fileName">
                                            <mat-icon class="mr-0" style=" vertical-align: middle; width: auto;
                                            height: auto;">cloud_upload</mat-icon>
                                            {{ "button.choose_another_file" | translate }}
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="4">
                                        <div style="display: block; height: 15px; width: 100%"></div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        <span style="font-weight: 600; white-space: no-wrap; 
                                        font-size: 12px;" class="mr-4">(
                                            <a (click)="downFileTemplateExcelAddIp($event)" class="file-name"
                                                style="text-decoration: underline;">{{
                                                "contract_lot.note_for_upload" | translate
                                                }}</a>)
                                        </span>
                                    </th>
                                    <td colspan="3">
                                        <i style="font-size: 12px;">{{
                                            "config_enterprise.validate_size" | translate
                                            }}</i>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="4">
                                        <div style="display: block; height: 30px; width: 100%"></div>
                                    </td>
                                </tr>
                                <tr *ngIf="fileResult">
                                    <td>
                                        {{"config_enterprise.result_import" | translate }}
                                    </td>
                                    <td colspan="3">
                                        <span style="font-weight: 600; white-space: no-wrap;" class="mr-4">
                                            <a (click)="getResultFile()" class="file-name"
                                                style="text-decoration: underline;">{{fileResult}}</a>
                                        </span>
                                    </td>
                                </tr>
                                <tr *ngIf="fileResult">
                                    <td>
                                        {{"config_enterprise.success" | translate }}
                                    </td>
                                    <td colspan="3">
                                        <span style="font-weight: 600; white-space: no-wrap;" class="mr-4">
                                            <a class="file-name" style="color: black !important; cursor: default;"
                                            >{{numberRecordSuccess}}</a>
                                        </span>
                                    </td>
                                </tr>
                                <tr *ngIf="fileResult">
                                    <td>
                                        {{"config_enterprise.fail" | translate }}
                                    </td>
                                    <td colspan="3">
                                        <span style="font-weight: 600; white-space: no-wrap;" class="mr-4">
                                            <a class="file-name" style="color: black !important; cursor: default;"
                                            >{{numberRecordFail}}</a>
                                        </span>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </mat-expansion-panel>
                <div class="pr-0 ">
                    <div class="text-center mat-elevation-z0 py-2 w-100" style="height: 60px">
                        <button id="btn-cancel" mat-stroked-button color="primary" class="mr-3" type="button"
                            (click)="onNoClick()">
                            <mat-icon class="mr-0">cancel</mat-icon>
                            {{ "button.cancel" | translate }}
                        </button>
                        <button mat-raised-button color="primary" class="mr-3" type="button" (click)="submit()"
                            [disabled]="!fileName">
                            <mat-icon class="mr-0">save</mat-icon>
                            {{ "config_enterprise.add_ip_with_file" | translate }}
                        </button>
                    </div>
                </div>
            </mat-accordion>
        </mat-card-content>
    </form>
</mat-card>
